import { Typography } from '@mui/material';
import React from 'react';
import * as TFF from '@tff/types/tff';
import { useBookingContext } from '../../../../hooks/use-booking-context';

interface CostBondRowProps {
  journey: TFF.Journey;
}

export const CostBondRow: React.FC<CostBondRowProps> = ({ journey }) => {
  const { timeFormatter, dateFormatter, weekdayFormatter } = useBookingContext();

  const firstSegment = journey.Segments[0];
  const lastSegment = journey.Segments[journey.Segments.length - 1];

  const departureDate = `${weekdayFormatter.format(new Date(firstSegment.DepartureTime))}. ${dateFormatter.format(new Date(firstSegment.DepartureTime))}`;
  const departureTime = timeFormatter.format(new Date(firstSegment.DepartureTime));
  const arrivalTime = timeFormatter.format(new Date(lastSegment.ArrivalTime));

  return (
    <div>
      <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
        {journey.Ond}
      </Typography>
      <Typography variant="body2">
        {departureDate}
        {`  ·  `}
        {`${departureTime} - ${arrivalTime}`}
      </Typography>
    </div>
  );
};

export default CostBondRow;
